import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDashboardMortgage = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5 4C4.44772 4 4 4.44772 4 5V6H10.382L9.65836 4.55279C9.48897 4.214 9.1427 4 8.76393 4H5ZM12.618 6L11.4472 3.65836C10.939 2.64201 9.90025 2 8.76393 2H5C3.34315 2 2 3.34315 2 5V19C2 20.6569 3.34315 22 5 22H19C20.6569 22 22 20.6569 22 19V9C22 7.34315 20.6569 6 19 6H12.618ZM11.9799 8C11.9938 8.00029 12.0077 8.00029 12.0217 8H19C19.5523 8 20 8.44772 20 9V19C20 19.5523 19.5523 20 19 20H5C4.44772 20 4 19.5523 4 19V8H11.9799Z",
		fill: "#534ABA"
	})
});
export default SvgDashboardMortgage;
